import { ZwaveService } from "./zwave.service";
import { ConfigurationProp } from "@app/shared/services/zwave-api/ConfigurationProp";

export { ZwaveService, ConfigurationProp };
